import _ from 'underscore';
import aggregations from './aggregations';
import ESRequest from './request';
import { transformGrowthMetrics, transformDailyGrowthMetrics, transformDailyCustomerMetrics, transformDailyLookbackMetrics, transformFrequentShippers, addCustomGrowthMetrics } from './transforms';
import { getDailyReportPeriods, getGrowthReportPeriods, getDailyReportLookbackPeriods, getFrequentShippersPeriod } from './periods';
const transformReportQuery = (query) => {
    let filters = {
        query: {
            canceled: false,
            accepted: true
        },
        deny: {
            status: ["en_route", "arrived", "needs_appt"]
        }
    };
    if (!_.isEmpty(query.market) && !query.market["*"]) {
        const keys = Object.keys(query.market);
        const markets = [];
        for (let mk in query.market) {
            if (query.market[mk]) {
                markets.push(mk);
            }
        }
        if (!_.isEmpty(markets) && markets.length) {
            filters.query.market = markets;
        }
    }
    if (query.shipperId) {
        filters.query.shipperId = query.shipperId;
        filters.query.project = false;
    }
    if (query.channel.insideSales && !query.channel.enterpriseSales)
        filters.query.enterpriseSales = false;
    if (query.channel.enterpriseSales && !query.channel.insideSales)
        filters.query.enterpriseSales = true;
    const shKeys = Object.keys(query.shipmentType);
    const shipmentTypes = [];
    for (let type in query.shipmentType) {
        if (query.shipmentType[type]) {
            shipmentTypes.push(type);
        }
    }
    if (!_.isEmpty(shipmentTypes) && shipmentTypes.length !== shKeys.length)
        filters.query.shipmentType = shipmentTypes;
    if (query.businessType.newStart && !query.businessType.existing)
        filters.query.firstShipperShipment = true;
    if (query.businessType.existing && !query.businessType.newStart)
        filters.query.firstShipperShipment = false;
    return filters;
};
export function match(nGram) {
    return {
        size: 5,
        sort: {
            createdDate: {
                order: 'desc'
            }
        },
        query: {
            filtered: {
                filter: {
                    missing: {
                        field: 'system'
                    }
                },
                query: {
                    match_phrase_prefix: {
                        _all: {
                            query: nGram,
                            operator: 'and'
                        }
                    }
                }
            }
        }
    };
}
;
export function receiveMatches(res) {
    return _.pluck(res.hits.hits, '_source');
}
;
export function getFrequentShippersRequest(date) {
    const request = new ESRequest()
        .aggregateInPeriods(getFrequentShippersPeriod(date), aggregations.frequentShipperAggregations);
    return request.body;
}
;
export function getGrowthReportRequest(date, query) {
    var filters = transformReportQuery(query);
    const request = new ESRequest()
        .query(filters)
        .aggregateInPeriods(getGrowthReportPeriods(date), aggregations.growthAggregations);
    return request.body;
}
;
export function getDailyReportGrowthRequest(date, query) {
    var filters = transformReportQuery(query);
    const request = new ESRequest()
        .query(filters)
        .aggregateInPeriods(getDailyReportPeriods(date), aggregations.dailyAggregations);
    return request.body;
}
;
export function getDailyReportCustomerRequest(date, query) {
    var filters = transformReportQuery(query);
    const request = new ESRequest()
        .query(filters)
        .aggregateInPeriods(getDailyReportPeriods(date), aggregations.dailyCustomerAggregations);
    return request.body;
}
;
export function getDailyReportLookbackRequest(date, query) {
    var filters = transformReportQuery(query);
    const request = new ESRequest()
        .query(filters)
        .aggregateInPeriods(getDailyReportLookbackPeriods(date), aggregations.dailyLookbackAggregations);
    return request.body;
}
;
export function receiveFrequentShippers(date, metrics) {
    return transformFrequentShippers(getFrequentShippersPeriod(date), metrics);
}
;
export function receiveGrowthMetrics(date, metrics) {
    const periods = getGrowthReportPeriods(date);
    return transformGrowthMetrics(periods, addCustomGrowthMetrics(periods, metrics));
}
;
export function receiveDailyReportGrowthMetrics(date, metrics) {
    return transformDailyGrowthMetrics(getDailyReportPeriods(date), metrics);
}
;
export function receiveDailyReportCustomerMetrics(date, metrics) {
    return transformDailyCustomerMetrics(getDailyReportPeriods(date), metrics);
}
;
export function receiveDailyReportLookbackMetrics(date, metrics) {
    return transformDailyLookbackMetrics(getDailyReportLookbackPeriods(date), metrics);
}
;
